import React from 'react';

export default function Footer() {
  const scrollToSection = (id: string) => {
    try {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } catch (error) {
      console.error('Error while trying to scroll:', error);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-700 to-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img src="https://static.readdy.ai/image/9aef2ecb0e026c2c4d4ac409bfdb68fc/25bdaa632620c1ec1bf0ef645ecb04bb.png" alt="Aura Align Physio" className="h-12 w-auto" />
              <span className="text-xl font-bold">Aura Align Physio</span>
            </div>
            <p className="text-teal-100 text-sm leading-relaxed">Your trusted partner in physiotherapy and wellness in Clontarf, QLD.</p>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['home', 'services', 'about', 'blog'].map((id) => (
                <li key={id}>
                  <button onClick={() => scrollToSection(id)} className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                    {id === 'about' ? 'About Us' : id.charAt(0).toUpperCase() + id.slice(1)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Our Services</h4>
            <ul className="space-y-2">
              <li className="text-teal-100 text-sm">Manual Therapy</li>
              <li className="text-teal-100 text-sm">Sports Injury Rehabilitation</li>
              <li className="text-teal-100 text-sm">Post-Surgical Rehabilitation</li>
              <li className="text-teal-100 text-sm">Chronic Pain Management</li>
              <li className="text-teal-100 text-sm">Movement Assessment</li>
              <li className="text-teal-100 text-sm">Medicare &amp; NDIS Physiotherapy</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-teal-300 mt-1"></i>
                <span className="text-teal-100 text-sm">Shop 1A/9 Elizabeth Ave, Clontarf QLD 4019</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-teal-300 mt-1"></i>
                <a href="tel:+61485683288" className="text-teal-100 hover:text-white text-sm cursor-pointer">+61 485 683 288</a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-teal-300 mt-1"></i>
                <a href="mailto:jagroop@auraalignphysio.com" className="text-teal-100 hover:text-white text-sm cursor-pointer">jagroop@auraalignphysio.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-teal-600 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-teal-100 text-sm">© 2025 Aura Align Physio. All rights reserved.</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-teal-100 hover:text-white text-sm mt-4 md:mt-0 cursor-pointer">Powered by Readdy</a>
        </div>
      </div>
    </footer>
  );
}
